module.exports = "https://www.gc-pro.gnp.com.mx/46ff04481a6237d77e0b2afc9a3b2651.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/directorio/5.png
// module id = 1026
// module chunks = 0 1